import * as React from 'react';
import { Layout } from 'react-admin';
import AppBar from './AppBar';

const CustomLayout = (props) => {
    return (
        <Layout
            {...props}
            appBar={AppBar}
        />
    );
};

export default CustomLayout;
